export default {
  'component.career.title.line1': 'Karriere hos Webmegling',
  'component.career.description':
    'Webmegling Technology er et internasjonalt selskap med ambisjoner om å bygge tilstedeværelse i stadig flere steder i Norge, samt at deler av vår teknologi utvikling foregår i verdensmetropolen New York. Vi er alltid på utkikk etter dyktige mennesker innen både fagområdene eiendomsmegling og teknologi utvikling.',
  'component.career.description1':
    'Vi søker særlig etter erfarne eiendomsmeglere som vil være med å utvikle måten boliger selges på i fremtiden, samt programutviklere som er interessert i å jobbe både i Norge og New York, USA.',
  'component.career.tableTitle': 'Utlyste stillinger',
};
